<svelte:options runes={false} />

<script>
  export let loginEmail;
  export let loginPassword;
  export let onLogin;
</script>

<form class="operator-login-form" on:submit|preventDefault={onLogin}>
  <label>
    Email
    <input autocomplete="email" bind:value={loginEmail} name="email" type="email" />
  </label>
  <label>
    Password
    <input autocomplete="current-password" bind:value={loginPassword} name="password" type="password" />
  </label>
  <button class="primary" type="submit">Sign in</button>
</form>
